<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='互动名称'>
                <el-input v-model='queryForm.interactName' style='width: 200px'></el-input>
            </el-form-item>
            <el-form-item label='礼物类型'>
                <el-select
                    v-model='queryForm.presentType'
                    placeholder='请选择礼物类型'
                    clearable
                    size='small'
                    style='width: 200px'
                >
                    <el-option v-for='item in interactPresentEnumList' :key='item.key' :label='item.value'
                               :value='item.key'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='礼物内容'>
                <el-input v-model='queryForm.presentDetail'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMarketInteractPresentList'>
                    查询
                </el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addMarketInteractPresent'
                    >新建
                    </el-button>
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMarketInteractPresent(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMarketInteractPresent(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
                    <!--                    <span-->
                    <!--                        title='下载模板'-->
                    <!--                        class='icon-box'-->
                    <!--                        @click='importTemplate'-->
                    <!--                    >-->
                    <!--                      <Icon color='#606266'>-->
                    <!--                        <ArrowDown />-->
                    <!--                      </Icon>-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                        class='icon-box'-->
                    <!--                        title='导入数据'-->
                    <!--                        @click='isImport'-->
                    <!--                    >-->
                    <!--                      <Icon color='#606266'>-->
                    <!--                        <ArrowExportUp24Regular />-->
                    <!--                      </Icon>-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                        title='导出数据'-->
                    <!--                        class='icon-box'-->
                    <!--                        @click='exportMarketInteractPresentList'-->
                    <!--                    >-->
                    <!--                      <Icon color='#606266'>-->
                    <!--                        <ArrowDownload24Regular />-->
                    <!--                      </Icon>-->
                    <!--                    </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMarketInteractPresentList'
                    >
                      <Icon color='#606266'>
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='marketInteractPresentList'
                row-key='id'
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='interactName'
                    label='互动名称'
                >
                    <template slot-scope='scop'>
                        <div>{{ scop.row.interactName + '('+ scop.row.interactType +')' }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='isActive'
                    label='是否激活'
                >
                    <template slot-scope='scop'>
                        <div>{{ scop.row.isActive == 1 ? '是' : '否' }}</div>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    prop='interactType'-->
<!--                    label='互动类型'-->
<!--                    -->
<!--                >-->
<!--                    <template slot-scope='scop'>-->
<!--                        <div>{{ computeInteractTypeEnum(scop.row.interactType) }}</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='presentType'
                    label='礼物类型'
                    
                >
                    <template slot-scope='scop'>
                        <div v-if="computeInteractPresentEnum(scop.row.presentType) !== false">{{ computeInteractPresentEnum(scop.row.presentType) + '('+ scop.row.presentType +')' }}</div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='presentDetail'
                    label='礼物内容'
                    
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='dictType'
                    label='字典类型'

                ></el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    prop='numberType'-->
<!--                    label='数量类型'-->
<!--                    -->
<!--                >-->
<!--                    <template slot-scope='scop'>-->
<!--                        <div>{{ computeInteractNumberTypeEnum(scop.row.numberType) }}</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    prop='presentNumber'-->
<!--                    label='礼物数量'-->
<!--                    -->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    prop='haveRequire'-->
<!--                    label='是否有要求'-->
<!--                    -->
<!--                >-->
<!--                    <template slot-scope='scop'>-->
<!--                        <div>{{ computeYesOrNo(scop.row.haveRequire) }}</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    prop='requireAmount'-->
<!--                    label='要求金额'-->
<!--                    -->
<!--                ></el-table-column>-->
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <MgJzD :typeId="scop.row.dictType" style="margin-left: 3px;"></MgJzD>
                            <div @click='showInteractRecord(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看领取记录</span>
                            </div>
                            <div @click='checkMarketInteractPresent(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMarketInteractPresent(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMarketInteractPresent(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='marketInteractPresentStates[marketInteractPresentState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='marketInteractPresent'
                        ref='marketInteractPresentForm'
                        :rules='rules'
                        label-width='130px'
                        :inline='true'
                        size='small'
                    >
                        <!-- <el-form-item
                            label='互动名称'
                            prop='interactName'
                        >
                            <el-input
                                size='small'
                                v-model='marketInteractPresent.interactName'
                                style='width: 200px'
                                :disabled="marketInteractPresentState == 'check'"
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item
                            label='互动名称'
                            prop='interactType'
                        >
                            <el-select
                                v-model='marketInteractPresent.interactType'
                                :disabled="marketInteractPresentState == 'check'"
                                placeholder='请选择互动名称'
                                clearable
                                size='small'
                                style='width: 200px'
                            >
                                <el-option v-for='item in interactTypeEnumList' :key='item.key' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="是否激活"
                            prop="isActive"
                        >
                            <!-- <el-input
                            size="small"
                            v-model="modelPlace.isActive"
                            :disabled="modelPlaceState == 'check'"
                            ></el-input> -->
                            <el-select
                                style="width: 200px;"
                                v-model="marketInteractPresent.isActive"
                                size="small"
                                placeholder="请选择"
                                :disabled="marketInteractPresentState == 'check'"
                            >
                                <el-option
                                    label="是"
                                    :value="1"
                                ></el-option>
                                <el-option
                                    label="否"
                                    :value="0"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='礼物类型'
                            prop='presentType'
                        >
                            <el-select
                                v-model='marketInteractPresent.presentType'
                                :disabled="marketInteractPresentState == 'check'"
                                placeholder='请选择礼物类型'
                                clearable
                                size='small'
                                @change='selectChange'
                                style='width: 200px'
                            >
                                <el-option v-for='item in interactPresentEnumList' :key='item.key' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <!--                        <el-form-item-->
                        <!--                            label='礼物内容'-->
                        <!--                            prop='presentDetail'-->
                        <!--                        >-->
                        <!--                            <el-input-->
                        <!--                                size='small'-->
                        <!--                                v-model='marketInteractPresent.presentDetail'-->
                        <!--                                style="width: 200px"-->
                        <!--                                :disabled="marketInteractPresentState == 'check'"-->
                        <!--                            ></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 1'
                            label='货币类型'
                            prop='presentDetail'
                        >
                            <el-select
                                size='small'
                                v-model='marketInteractPresent.presentDetail'
                                style='width: 200px'
                                placeholder='请选择赠送的货币类型'
                                :disabled="marketInteractPresentState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in currencyTypeEnumList'
                                    :key='index'
                                    :label='item.value'
                                    :value='item.key'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 2'
                            label='会员等级'
                            prop='presentDetail'
                        >
                            <el-select
                                size='small'
                                v-model='marketInteractPresent.presentDetail'
                                style='width: 200px'
                                placeholder='请选择赠送的会员等级'
                                :disabled="marketInteractPresentState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in currencyEnumList'
                                    :key='index'
                                    :label='item.value'
                                    :value='item.key'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 3'
                            label='选择商城商品'
                            prop='presentDetail'
                        >
                            <GridSelect
                                style="width: 200px"
                                title="选择商城商品"
                                labelName="productName"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择商城商品"
                                @getValue="getValueProduct"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 4'
                            label='选择餐饮商品'
                            prop='presentDetail'
                        >
                            <GridSelect
                                style="width: 200px"
                                title="选择餐饮商品"
                                labelName="productName"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择餐饮商品"
                                @getValue="getValueProduct"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/restaurant/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/restaurant/product/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 5'
                            label='选择洗护商品'
                            prop='presentDetail'
                        >
                            <GridSelect
                                style="width: 200px"
                                title="选择洗护商品"
                                labelName="productName"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择洗护商品"
                                @getValue="getValueProduct"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/washcloud/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/washcloud/product/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 6'
                            label='选择商城优惠券'
                            prop='presentDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择商城优惠券"
                                labelName="couponName"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择商城优惠券"
                                @getValue="getValueCoupon"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="COUPON_code"
                                :searchs="COUPON_search"
                                dataListUrl="/shop/coupon/findList"
                                entityBeanName="shopCoupon"
                                queryEntityUrl="/shop/coupon/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 7'
                            label='选择餐饮优惠券'
                            prop='presentDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择餐饮优惠券"
                                labelName="couponName"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择餐饮优惠券"
                                @getValue="getValueCoupon"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="COUPON_code"
                                :searchs="COUPON_search"
                                dataListUrl="/restaurant/coupon/findList"
                                entityBeanName="shopCoupon"
                                queryEntityUrl="/restaurant/coupon/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 8'
                            label='选择洗护优惠券'
                            prop='presentDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择洗护优惠券"
                                labelName="couponName"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择洗护优惠券"
                                @getValue="getValueCoupon"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="COUPON_code"
                                :searchs="COUPON_search"
                                dataListUrl="/washcloud/coupon/findList"
                                entityBeanName="shopCoupon"
                                queryEntityUrl="/washcloud/coupon/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 9'
                            label='选择红包'
                            prop='presentDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择红包"
                                labelName="leftAmount"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择红包"
                                @getValue="getValuePacket"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="PACKET_code"
                                :searchs="PACKET_search"
                                dataListUrl="/shop/shopredpacket/findList"
                                entityBeanName="shopRedPacket"
                                queryEntityUrl="/shop/shopredpacket/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 10'
                            label='选择购物卡'
                            prop='presentDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择购物卡"
                                labelName="money"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择购物卡"
                                @getValue="getValueCardCash"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="CARD_code"
                                :searchs="CARD_search"
                                dataListUrl="/shop/shopcardshopping/findList"
                                entityBeanName="shopCardCash"
                                queryEntityUrl="/shop/shopcardshopping/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketInteractPresent.presentType === 11'
                            label='选择礼品卡'
                            prop='presentDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择礼品卡"
                                labelName="id"
                                labelValue="id"
                                :value="marketInteractPresent.presentDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择礼品卡"
                                @getValue="getValuePacket"
                                :disabled="marketInteractPresentState == 'check'"
                                :columns="[
                                    {
                                        prop: 'product.productName',
                                        label: '礼品',
                                        img: 'twolabel'
                                    },
                                    {
                                        prop: 'expiredTime',
                                        label: '过期时间(年)',
                                    }
                                ]"
                                :searchs="[
                                    {
                                        prop: 'productName',
                                        label: '礼品',
                                    }
                                ]"
                                dataListUrl="/shop/shopcardpresent/findList"
                                entityBeanName="shopCardPresent"
                                queryEntityUrl="/shop/shopcardpresent/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>


<!--                        <el-form-item-->
<!--                            label='数量类型'-->
<!--                            prop='numberType'-->
<!--                        >-->
<!--                            <el-select-->
<!--                                v-model='marketInteractPresent.numberType'-->
<!--                                :disabled="marketInteractPresentState == 'check'"-->
<!--                                placeholder='请选择数量类型'-->
<!--                                clearable-->
<!--                                size='small'-->
<!--                                style='width: 200px'-->
<!--                            >-->
<!--                                <el-option v-for='item in interactNumberTypeEnumList' :key='item.key'-->
<!--                                           :label='item.value' :value='item.key'></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label='礼物数量'-->
<!--                            prop='presentNumber'-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size='small'-->
<!--                                v-model='marketInteractPresent.presentNumber'-->
<!--                                style='width: 200px'-->
<!--                                :disabled="marketInteractPresentState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label='是否有要求'-->
<!--                            prop='haveRequire'-->
<!--                            v-if='marketInteractPresent.interactType == 3 || marketInteractPresent.interactType == 4'-->
<!--                        >-->
<!--                            <el-select-->
<!--                                v-model='marketInteractPresent.haveRequire'-->
<!--                                :disabled="marketInteractPresentState == 'check'"-->
<!--                                placeholder='请选择是否有要求'-->
<!--                                clearable-->
<!--                                size='small'-->
<!--                                style='width: 200px'-->
<!--                            >-->
<!--                                <el-option v-for='item in yesOrNoEnumList' :key='item.key' :label='item.value'-->
<!--                                           :value='item.key'></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label='要求金额'-->
<!--                            prop='requireAmount'-->
<!--                            v-if='marketInteractPresent.interactType == 3 || marketInteractPresent.interactType == 4'-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size='small'-->
<!--                                v-model='marketInteractPresent.requireAmount'-->
<!--                                style='width: 200px'-->
<!--                                :disabled="marketInteractPresentState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="字典类型"
                            prop="dictType"
                        >
                            <el-input
                            size="small"
                            style="width: 200px"
                            v-model="marketInteractPresent.dictType"
                            :disabled="marketInteractPresentState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="marketInteractPresentState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
            <el-drawer
                title="互动有礼记录"
                :visible.sync="interactRecordStatus"
                direction="rtl"
                size="70%"
                :before-close="closeInteractRecord">
                <MarketInteractRecord :interactId='interactId' ref='marketInteractRecord'></MarketInteractRecord>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/gidselect.vue';
import GridSelectIndex from '@/components/gridselect/gidselect.vue';
import MarketInteractRecord from './MarketInteractRecord.vue';
import MgJzD from '@/components/model/modelPlace.vue';
import { PRODUCT, PRODUCT_SEARCH, PACKET, PACKET_SEARCH, COUPON, COUPON_SEARCH, CARD, CARD_SEARCH } from '@/utils/constant.js'
export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MarketInteractRecord,
        GridSelectIndex,
        MgJzD
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMarketInteractPresentList();
                this.getMarketInteractPresentList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMarketInteractPresentList();
                this.getMarketInteractPresentList();
                this.$emit('resetCheckState');
            }
        },
        marketInteractPresent:{
            deep: true,
            handler(newValues){
                console.log(newValues)
            },
        }
    },
    data() {
        return {
            PRODUCT_search: PRODUCT_SEARCH,
            PRODUCT_code: PRODUCT,
            PACKET_code: PACKET,
            PACKET_search: PACKET_SEARCH,
            COUPON_search: COUPON_SEARCH,
            COUPON_code: COUPON,
            CARD_code: CARD,
            CARD_search: CARD_SEARCH,
            interactId: '',
            interactRecordStatus: false,
            yesOrNoEnumList: [],
            interactNumberTypeEnumList: [],
            interactPresentEnumList: [],
            interactTypeEnumList: [],
            currencyTypeEnumList: [],

            queryForm: {
                interactName: '', //互动名称
                interactType: '', //互动类型
                presentType: '', //礼物类型
                presentDetail: '', //礼物内容
                numberType: '', //数量类型 1值数 2比例
                presentNumber: '', //礼物数量
                haveRequire: '', //是否有要求 1有 0没有
                requireAmount: '' //要求金额
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            marketInteractPresentState: 'add',
            marketInteractPresentStates: {
                add: '新建互动有礼',
                check: '查看互动有礼',
                edit: '修改互动有礼'
            },

            multipleSelection: [],
            marketInteractPresentList: [],
            marketInteractPresent: {
                interactName: '', //互动名称
                interactType: '', //互动类型
                presentType: '', //礼物类型
                presentDetail: '', //礼物内容
                numberType: '', //数量类型 1值数 2比例
                presentNumber: '', //礼物数量
                haveRequire: '', //是否有要求 1有 0没有
                requireAmount: '', //要求金额
                isActive: '',
                dictType: ''

            },
            btnLoading: false,
            currencyEnumList: [],
            rules: {
                interactName: [{ required: true, message: '互动名称不能为空', trigger: 'blur' }],
                interactType: [{ required: true, message: '互动类型不能为空', trigger: 'blur' }],
                presentType: [{ required: true, message: '礼物类型不能为空', trigger: 'blur' }],
                presentDetail: [{ required: true, message: '礼物内容不能为空', trigger: 'blur' }],
                numberType: [{ required: true, message: '数量类型 1值数 2比例不能为空', trigger: 'blur' }],
                presentNumber: [{ required: true, message: '礼物数量不能为空', trigger: 'blur' }],
                haveRequire: [{ required: true, message: '是否有要求 1有 0没有不能为空', trigger: 'blur' }],
                requireAmount: [{ required: true, message: '要求金额不能为空', trigger: 'blur' }],
                isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMarketInteractPresentList();
        this.getInteractTypeEnum();
        this.getInteractPresentEnum();
        this.getInteractNumberTypeEnum();
        this.getYesOrNoEnum();
        this.getCurrencyTypeEnum();
        this.getCurrencyType();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        //获取currency_type枚举
        getCurrencyType() {
            get('/mpp/utils/getEnum', {
                enumType: 'grade'
            }).then((res) => {
                this.currencyEnumList = res.enumList;
            });
        },
        resetMarketInteractPresentList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.marketInteractPresentList = [];
        },
        resetDialog() {
            this.marketInteractPresentState = 'add';
            this.showDialog = false;
            this.queryForm = {
                interactName: '', //互动名称
                interactType: '', //互动类型
                presentType: '', //礼物类型
                presentDetail: '', //礼物内容
                numberType: '', //数量类型 1值数 2比例
                presentNumber: '', //礼物数量
                haveRequire: '', //是否有要求 1有 0没有
                requireAmount: '' //要求金额
            };
            this.getMarketInteractPresentList();
        },
        closeDialog() {
            this.showDialog = false;
            this.marketInteractPresent = {
                interactName: '', //互动名称
                interactType: '', //互动类型
                presentType: '', //礼物类型
                presentDetail: '', //礼物内容
                numberType: '', //数量类型 1值数 2比例
                presentNumber: '', //礼物数量
                haveRequire: '', //是否有要求 1有 0没有
                requireAmount: '', //要求金额
                isActive: '',
                dictType: ''
                
            };
        },
        submitForm() {
            if (this.marketInteractPresentState == 'add') {
                this.$refs.marketInteractPresentForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/interactpresent/add`, { ...this.marketInteractPresent }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketInteractPresentList();
                                this.resetDialog();
                                this.getMarketInteractPresentList();
                            }
                        });
                    }
                });
            } else if (this.marketInteractPresentState == 'edit') {
                this.$refs.marketInteractPresentForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/interactpresent/edit`, { ...this.marketInteractPresent }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketInteractPresentList();
                                this.resetDialog();
                                this.getMarketInteractPresentList();
                            }
                        });
                    }
                });
            }
        },
        addMarketInteractPresent() {
            this.showDialog = true;
            this.marketInteractPresentState = 'add';
        },
        checkMarketInteractPresent(marketInteractPresentId) {
            console.log(marketInteractPresentId);
            this.currentMarketInteractPresentId = marketInteractPresentId;

            this.getMarketInteractPresentById();
            this.showDialog = true;
            this.marketInteractPresentState = 'check';
        },
        editMarketInteractPresent(marketInteractPresentId) {
            console.log('marketInteractPresent', marketInteractPresentId);
            if (marketInteractPresentId) {
                this.currentMarketInteractPresentId = marketInteractPresentId;
                this.getMarketInteractPresentById();
            } else {
                this.marketInteractPresent = { ...this.marketInteractPresent, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.marketInteractPresentState = 'edit';
        },
        deleteMarketInteractPresent(marketInteractPresentId) {
            let ids = '';
            if (marketInteractPresentId) {
                ids = marketInteractPresentId;
            } else {
                ids = this.multipleSelection.map((marketInteractPresent) => marketInteractPresent.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/market/interactpresent/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMarketInteractPresentList();
                            this.getMarketInteractPresentList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMarketInteractPresentList() {
            this.resetMarketInteractPresentList();
            this.getMarketInteractPresentList();
        },
        getMarketInteractPresentList(query = {}) {
            this.loading = true;
            get(`/market/interactpresent/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.marketInteractPresentList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMarketInteractPresentById() {
            get(`/market/interactpresent/get`, { id: this.currentMarketInteractPresentId }).then((res) => {
                if (res.success) {
                    this.marketInteractPresent = { ...this.marketInteractPresent, ...res.marketInteractPresent };
                    if(this.marketInteractPresent.presentType === 1){
                        this.marketInteractPresent.presentDetail = Number(this.marketInteractPresent.presentDetail);
                    }
                }
            });
        },
        /**
         * 导出信息
         */
        exportMarketInteractPresentList() {
            //this.btnLoading = true;
            exprotExcel(`/market/interactpresent/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/market/interactpresent/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/market/interactpresent/importData`, formData);
            this.refreshMarketInteractPresentList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMarketInteractPresentList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMarketInteractPresentList();
        },
        selectChange(){
            this.marketInteractPresent.presentDetail = ''
        },
        getValueProduct(value){
            this.marketInteractPresent.presentDetail = value
        },
        getValueCoupon(value){
            this.marketInteractPresent.presentDetail = value
        },
        getValuePacket(value){
            this.marketInteractPresent.presentDetail = value
        },
        getValueCardCash(value){
            this.marketInteractPresent.presentDetail = value
        },

        // 获取InteractTypeEnum
        getInteractTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'interact_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.interactTypeEnumList = res.enumList;
                }
            });
        },

        // 获取InteractPresentEnum
        getInteractPresentEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'interact_present'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.interactPresentEnumList = res.enumList;
                }
            });
        },

        // 获取InteractNumberTypeEnum
        getInteractNumberTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'interact_number_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.interactNumberTypeEnumList = res.enumList;
                }
            });
        },

        // 获取 YesOrNoEnum
        getYesOrNoEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'yes_no'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.yesOrNoEnumList = res.enumList;
                }
            });
        },

        // 获取 CurrencyTypeEnum
        getCurrencyTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'currency_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.currencyTypeEnumList = res.enumList;
                }
            });
        },

        // 计算InteractTypeEnum
        computeInteractTypeEnum(type) {
            for (let i = 0; i < this.interactTypeEnumList.length; i++) {
                if (this.interactTypeEnumList[i].key === type) {
                    return this.interactTypeEnumList[i].value;
                }
            }
        },

        // 计算InteractPresentEnum
        computeInteractPresentEnum(type) {
            for (let i = 0; i < this.interactPresentEnumList.length; i++) {
                if (this.interactPresentEnumList[i].key === type) {
                    return this.interactPresentEnumList[i].value;
                }
            }
            return false;
        },

        // 计算InteractTypeEnum
        computeInteractNumberTypeEnum(type) {
            for (let i = 0; i < this.interactNumberTypeEnumList.length; i++) {
                if (this.interactNumberTypeEnumList[i].key === type) {
                    return this.interactNumberTypeEnumList[i].value;
                }
            }
        },

        // 计算YesOrNo
        computeYesOrNo(type) {
            for (let i = 0; i < this.yesOrNoEnumList.length; i++) {
                if (this.yesOrNoEnumList[i].key === type) {
                    return this.yesOrNoEnumList[i].value;
                }
            }
        },

        showInteractRecord(id){
            this.interactId = id
            this.interactRecordStatus = true
            this.$nextTick(()=>{
                this.$refs.marketInteractRecord.getMarketInteractRecordList();
            })
        },

        closeInteractRecord() {
            this.interactId = ''
            this.interactRecordStatus = false
        }
    }
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>